import { Fragment, useEffect } from 'react';
import { v4 as uuid } from 'uuid';
import DOMPurify from 'dompurify';
import { Grid, Link, Typography } from '@mui/material';
import LinkData from '../../../../models/LinkData';
import Utils from '../../../../utils/Utils';
import CloseButton from '../../../Buttons/Close';

import BlockSettings from '../../../../models/BlockSettings';

interface HeaderMenuProps {
  menus: LinkData[];
  headerSettings: BlockSettings;
  isEditing: boolean;
  showSeparators?: boolean;
  direction?: 'row' | 'column';
  handleMenuDelete: () => void;
  handleOpen: () => void;
}

const sanitizer = DOMPurify.sanitize;

const HeaderMenu = ({
  menus, headerSettings, isEditing, direction = 'row', handleMenuDelete, handleOpen, showSeparators = false,
}: HeaderMenuProps) => {
  useEffect(() => {
    document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
      anchor.addEventListener('click', (e) => {
        e.preventDefault();

        let href = anchor.getAttribute('href');
        href = href.replace('#', '');

        if (href && href !== '#' && href !== '#!') {
          const headerEl = document.querySelector('.blockHeaderType');
          const headerOffset = headerEl ? headerEl.clientHeight : 0;

          const targetEl = document.getElementById(href);
          if (targetEl) targetEl.style.scrollMarginTop = `${headerOffset}px`;

          if (targetEl) {
            targetEl.scrollIntoView({
              behavior: 'smooth',
            });
          }
        }
      });
    });
  }, [menus]);

  return (
    <Grid item xs={12} sx={{ ...Utils.hoverBorder(isEditing), padding: '16px' }}>
      {isEditing && <CloseButton updateHandler={handleMenuDelete} />}
      <Grid
        container
        spacing={2}
        direction={direction}
        alignItems={headerSettings?.align}
        justifyContent={headerSettings?.justify}
        wrap="wrap"
        onClick={handleOpen}
      >
        {menus.map((menu) => (
          <Fragment key={uuid()}>
            <Grid key={uuid()} item xs="auto">
              {!isEditing && (
                <Link
                  href={menu.linkData.url}
                  target={menu.linkData.openType}
                  rel="noreferrer"
                  underline="hover"
                  color="black"
                  variant="h6"
                  m="auto"
                >
                  <div
                    translate="no"
                    className="notranslate"
                    dangerouslySetInnerHTML={{ __html: sanitizer(menu.title) }}
                  />
                </Link>
              )}

              {isEditing && (
                <Typography color="black" variant="h6" m="auto">
                  <div
                    translate="no"
                    className="notranslate"
                    dangerouslySetInnerHTML={{ __html: sanitizer(menu.title) }}
                  />
                </Typography>
              )}
            </Grid>

            {(menus.indexOf(menu) !== menus.length - 1 && showSeparators) && (
              <Grid item xs="auto" style={{ fontSize: '20px', color: headerSettings?.separatorColor }}>
                {headerSettings?.separator}
              </Grid>
            )}
          </Fragment>
        ))}
      </Grid>
    </Grid>
  );
};
export default HeaderMenu;
